;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="54aada13-df85-401d-882f-0cefef9f901b",e._sentryDebugIdIdentifier="sentry-dbid-54aada13-df85-401d-882f-0cefef9f901b")}catch(e){}}();
(self["webpackChunkretino"] = self["webpackChunkretino"] || []).push([[664],{

/***/ 58345:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var url_search_params_polyfill__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48318);
/* harmony import */ var url_search_params_polyfill__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(url_search_params_polyfill__WEBPACK_IMPORTED_MODULE_0__);
// Polyfill URLSearchParams class for Edge 16 and less


// Polyfill event.composedPath() for Edge
(function (E, d, w) {
  if (!E.composedPath) {
    E.composedPath = function () {
      if (this.path) {
        return this.path;
      }
      let target = this.target;

      this.path = [];
      while (target.parentNode !== null) {
        this.path.push(target);
        target = target.parentNode;
      }
      this.path.push(d, w);
      return this.path;
    };
  }
})(Event.prototype, document, window);

// All settled polyfill
Promise.allSettled =
  Promise.allSettled ||
  ((promises) =>
    Promise.all(
      promises.map((p) =>
        p
          .then((value) => ({
            status: 'fulfilled',
            value,
          }))
          .catch((reason) => ({
            status: 'rejected',
            reason,
          })),
      ),
    ));


/***/ }),

/***/ 83731:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ([
  'Non-Error exception captured',
  'Non-Error promise rejection captured',
  'Request has been terminated',
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
  'The request failed and the interceptors did not return an alternative response',
  'TypeError: Load failed',
  "Can't find variable: $",
  'NetworkError when attempting to fetch resource',
  'Failed to fetch',
  'sbrowserTsBridge',
  'SymBrowser',
  'Blocked a frame with origin',
]);


/***/ }),

/***/ 1858:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ([/\/mapsjs-core.js/, /\/clarity/]);


/***/ }),

/***/ 53199:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var mobx_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44015);
/* harmony import */ var stores_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9432);




/**
 * We use recommended solution proposed by react-router team, but instead of using (react-router).useLocation() we
 * add listener to our history object.
 */
function ScrollToTop() {
  const history = (0,stores_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useHistory */ .W6)();
  const [pathname, setPathname] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('');
  const unregisterRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const historyListener = (location, action) => {
    if (pathname !== location) {
      var _document$getElementB;
      (_document$getElementB = document.getElementById('retino')) === null || _document$getElementB === void 0 || _document$getElementB.scroll(0, 0);
    }
    setPathname(location);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    if (unregisterRef.current) {
      unregisterRef.current();
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (unregisterRef.current) {
      unregisterRef.current();
    }
    unregisterRef.current = history.listen(historyListener);
  }, [pathname]);
  return null;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react__WEBPACK_IMPORTED_MODULE_2__/* .observer */ .PA)(ScrollToTop));

/***/ }),

/***/ 35810:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35443);
const _excluded = ["removeError", "isOutdated"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


function DefaultFallback(_ref) {
  let {
      removeError,
      isOutdated
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (isOutdated) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "flex justify-center pt-12"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Segment */ .Y4, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "flex max-w-lg flex-col items-center text-center"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "mx-auto mb-4 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
      name: "rewind",
      className: "h-6 w-6 text-red-600"
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", {
      className: "text-lg font-bold"
    }, gettext('New version of Retino available.')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
      className: "my-1 text-sm text-gray-800"
    }, gettext("We've just released a new version of Retino.")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "mt-4 flex justify-center gap-2"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .$n, {
      primary: true,
      onClick: () => window.location.reload()
    }, gettext('Refresh'))))));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex justify-center pt-12"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Segment */ .Y4, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex max-w-lg flex-col items-center text-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "mx-auto mb-4 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    name: "exclamation",
    className: "h-6 w-6 text-red-600"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", {
    className: "text-lg font-bold"
  }, gettext("There was an error and we couldn't process your request.")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "my-1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "my-1 text-sm text-gray-800"
  }, gettext('Please reload the page and try again. If the error prevails, please contact our support and we will help you.')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "mt-4 flex justify-center gap-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .$n, {
    primary: true,
    onClick: () => window.location.reload()
  }, gettext('Try again')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Popup */ .zD, {
    on: "hover",
    trigger: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .$n, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
      href: "mailto:support@retino.com"
    }, gettext('Contact support')))
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, "support@retino.com"))))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DefaultFallback);

/***/ }),

/***/ 15072:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function toast(item) {
  if (item.description instanceof Error) {
    // A stray Error object passed as description would crash the root ToastContainer
    // ("Objects are not valid as a React child") and white-screen the whole app.
    item.description = item.description.message;
  }
  window.appState.toastStore.addToast(item);
}
const success = function (message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  toast({
    type: 'success',
    title: options.title || gettext('Success'),
    description: message
  });
};
const error = function (message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  toast({
    type: 'error',
    title: options.title || gettext('Error'),
    description: message || gettext('Oops. Something went wrong.')
  });
};
const errorBadRequest = function (message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  toast({
    type: 'error',
    title: options.title || gettext('Error'),
    description: message || gettext('Please correct the highlighted fields.')
  });
};
const info = function (message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  toast({
    type: 'info',
    title: options.title || gettext('Info'),
    description: message
  });
};
const warning = function (message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  toast({
    type: 'warning',
    title: options.title || gettext('Warning'),
    description: message
  });
};
const itemSaved = message => {
  toast({
    type: 'success',
    title: gettext('Success'),
    description: message || gettext('Item was saved successfuly.')
  });
};
const itemDeleted = message => {
  toast({
    type: 'success',
    title: gettext('Success'),
    description: message || gettext('Item was deleted successfuly.')
  });
};
const settingsSaved = message => {
  toast({
    type: 'success',
    title: gettext('Success'),
    description: message || gettext('Settings were saved successfuly.')
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  success,
  error,
  errorBadRequest,
  warning,
  info,
  itemSaved,
  itemDeleted,
  settingsSaved
});

/***/ }),

/***/ 56858:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function LogoIcon() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    viewBox: "0 0 863 252",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M105.195 117.065H59.6488C55.204 117.065 51.3709 118.897 48.1498 122.554C44.9286 126.212 43.315 130.373 43.315 135.024V250.754H0V134.689C0 124.273 2.54935 114.79 7.66605 106.253C12.7708 97.7228 19.717 90.9043 28.4927 85.7979C37.2685 80.7034 46.7641 78.1472 56.9855 78.1472H105.195V117.053V117.065Z",
    fill: "currentColor"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M174.753 202.868C181.303 209.519 190.691 212.848 202.91 212.848C208.458 212.848 213.407 211.908 217.738 210.022C222.069 208.142 225.62 205.754 228.403 202.874C231.174 199.995 233.01 196.888 233.898 193.559H278.55C277.663 200.21 274.549 208.029 269.217 217.002C263.884 225.982 255.666 234.022 244.557 241.116C233.448 248.21 219.567 251.753 202.904 251.753C186.462 251.753 171.688 247.988 158.581 240.445C145.474 232.914 135.139 222.438 127.593 209.016C120.035 195.607 116.262 180.581 116.262 163.957C116.262 147.775 120.095 132.977 127.755 119.561C135.421 106.152 145.75 95.5618 158.743 87.8034C171.736 80.045 186.012 76.1658 201.56 76.1658C216.22 76.1658 229.663 80.1048 241.882 87.971C254.095 95.8431 263.764 106.427 270.872 119.729C277.981 133.031 281.538 147.554 281.538 163.292C281.538 167.728 281.316 172.05 280.872 176.265H162.246C164.022 187.352 168.185 196.217 174.741 202.868H174.753ZM176.75 123.554C170.422 129.205 166.139 137.024 163.926 146.997H236.237C235.121 140.568 233.124 135.024 230.239 130.367C227.347 125.709 223.46 121.998 218.578 119.226C213.689 116.454 208.026 115.072 201.584 115.072C191.363 115.072 183.085 117.897 176.75 123.554Z",
    fill: "currentColor"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M403.182 117.065V78.1593H361.864V29.2742H317.548V78.1593H289.889V117.065H318.213V193.218C318.213 203.641 320.547 213.171 325.208 221.815C329.875 230.46 336.257 237.278 344.367 242.271C352.471 247.258 361.636 249.754 371.858 249.754H400.519V208.849H377.856C372.98 208.849 368.955 207.155 365.775 203.766C362.92 200.713 361.522 196.553 361.522 192.374V117.065H403.182Z",
    fill: "currentColor"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M427.615 49.9806C422.27 44.3893 419.571 37.6845 419.511 29.8603C419.451 22.0899 422.51 14.3973 427.969 8.85391C433.781 2.9513 440.847 0 449.167 0C457.271 0 464.151 2.65797 469.802 7.97391C475.518 13.3497 478.962 20.9884 479.147 28.8246C479.345 37.1338 476.352 44.3234 470.162 50.3817C463.959 56.4579 456.689 59.3913 448.345 59.1817C440.565 58.9902 432.989 55.6019 427.615 49.9806ZM426.841 249.753V78.1587H471.163V249.759L426.841 249.753Z",
    fill: "currentColor"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M617.113 158.97C617.113 146.997 614.167 137.574 608.283 130.702C602.392 123.829 594.342 120.393 584.121 120.393H583.785C573.342 120.393 565.124 123.835 559.125 130.702C553.127 137.574 550.128 146.997 550.128 158.97V249.76H506.807V158.97C506.807 143.004 510.082 128.762 516.638 116.233C523.188 103.709 532.3 93.8972 543.961 86.8033C555.622 79.7094 568.897 76.1594 583.785 76.1594H584.121C598.337 76.1594 611.282 79.7094 622.943 86.8033C634.604 93.9032 643.77 103.715 650.434 116.233C657.098 128.762 660.434 143.004 660.434 158.97V249.76H617.113V158.97Z",
    fill: "currentColor"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M774.347 76.1536C725.76 76.1536 686.35 115.424 686.35 163.914L708.004 185.585L729.659 163.914C729.659 139.31 749.694 119.376 774.347 119.376C799.001 119.376 818.976 139.31 818.976 163.914C818.976 188.519 799.001 208.513 774.347 208.513C761.99 208.513 750.833 203.545 742.735 195.463L712.143 226.053C728.039 241.917 750.053 251.735 774.347 251.735C822.935 251.735 862.345 212.464 862.345 163.914C862.345 115.365 822.935 76.1536 774.347 76.1536Z",
    fill: "currentColor"
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LogoIcon);

/***/ }),

/***/ 28720:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   OW: () => (/* binding */ ApiClient)
/* harmony export */ });
/* unused harmony exports AddressAddressApi, AuthAcceptInvitationApi, AuthEmailAvailableApi, AuthLoginApi, AuthPasswordResetApi, AuthPasswordSetApi, AuthRegisterApi, AuthRegisterValidateDetailsApi, AuthTwoFactorVerifyApi, BadgeBadgeReportCommentsApi, BadgeCanRetainBadgeApi, BillingStripeWebhookApi, ClientRatingCommentApi, ClientTicketApi, ClientTicketMessagesApi, ClientTicketProductCustomFieldTypesApi, ClientTicketProductsApi, ClientTicketUnsubscribeApi, CompanyCompanyApi, CompanyWebhookPipedriveMergeApi, FilesFileUploadRequestApi, FilesFileUploadRequestUploadedApi, FilesFilesApi, MarketplaceRemarketingSettingsApi, MarketplaceRemarketingCallRequestApi, MarketplaceRemarketingCreateVoucherApi, MonitoringEventApi, OnboardingPlatformIntegrateApi, OnboardingPlatformIntegrationApi, PortalFormApi, PortalFormAuthApi, PortalFormAuthCreateWithoutOrderApi, PortalFormAuthSendVerificationMailApi, PortalFormProgressApi, PortalFormProgressCreateIntentApi, PortalFormProgressCreateTicketApi, PortalFormProgressExchangeCatalogApi, PortalFormProgressExchangeMethodsApi, PortalFormProgressExchangePreviewApi, PortalFormProgressExchangeVariantsApi, PortalFormProgressExchangeWizardApi, PortalFormProgressShippingRouteApi, PortalFormProgressShippingRoutesApi, PortalGeoDataByCoordsApi, PortalGeoDataByQueryApi, PortalNpsSurveyApi, PortalPlaceDetailApi, ShippingPortalGeoDataByQueryApi, ShippingRatingApi, ShippingDropOffBranchApi, ShippingDropOffBranchNearestFromCenterApi, ShippingProvidersConfigApi, TransportRatingApi, TransportDropOffBranchNearestApi, TransportDropOffBranchApi, TransportFetchDropOffBranchesApi, TransportMakeWebhookMyGlsInternationalTrackingNumberApi, TransportShippingRatingApi */
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10895);

class AddressAddressApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/address/address', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async options() {
    const response = await this.request('/address/address', 'OPTIONS', {}, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/address/address/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/address/address/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/address/address/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/address/address/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/address/address/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class AuthAcceptInvitationApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/auth/accept-invitation/{id}', 'POST', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class AuthEmailAvailableApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/auth/email-available', 'GET', {}, {
      email: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.email
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class AuthLoginApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/auth/login', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class AuthPasswordResetApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/auth/password-reset', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
  }
}
class AuthPasswordSetApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/auth/password-set', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
  }
}
class AuthRegisterApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/auth/register', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class AuthRegisterValidateDetailsApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/auth/register/validate-details', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
  }
}
class AuthTwoFactorVerifyApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/auth/two-factor/verify', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
  }
}
class BadgeBadgeReportCommentsApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async list(requestParameters) {
    const response = await this.request('/badge/badge-report-comments/{company_id}/{language}', 'GET', {
      company_id: requestParameters.company_id,
      language: requestParameters.language
    }, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class BadgeCanRetainBadgeApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/badge/can-retain-badge/{company_id}/', 'GET', {
      company_id: requestParameters.company_id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class BillingStripeWebhookApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create() {
    const response = await this.request('/billing/stripe-webhook', 'POST', {}, undefined, undefined);
  }
}
class ClientRatingCommentApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/client/rating-comment/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/client/rating-comment/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/client/rating-comment/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/client/rating-comment/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class ClientTicketApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/client/ticket/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class ClientTicketMessagesApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/client/ticket/{id}/messages', 'POST', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class ClientTicketProductCustomFieldTypesApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async list(requestParameters) {
    const response = await this.request('/client/ticket/{id}/product-custom-field-types', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class ClientTicketProductsApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async list(requestParameters) {
    const response = await this.request('/client/ticket/{id}/products', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class ClientTicketUnsubscribeApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/client/ticket/{id}/unsubscribe/{hashcode}', 'POST', {
      hashcode: requestParameters.hashcode,
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class CompanyCompanyApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/company/company/{id}/', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class CompanyWebhookPipedriveMergeApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create() {
    const response = await this.request('/company/webhook-pipedrive-merge', 'POST', {}, undefined, undefined);
  }
}
class FilesFileUploadRequestApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/files/file-upload-request/', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class FilesFileUploadRequestUploadedApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/files/file-upload-request/{id}/uploaded/', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class FilesFilesApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/files/files/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class MarketplaceRemarketingSettingsApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/marketplace/remarketing-settings', 'GET', {}, {
      ticket_id: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket_id
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class MarketplaceRemarketingCallRequestApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/marketplace/remarketing/{settings_id}/call-request', 'POST', {
      settings_id: requestParameters.settings_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
  }
}
class MarketplaceRemarketingCreateVoucherApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/marketplace/remarketing/{settings_id}/create-voucher', 'POST', {
      settings_id: requestParameters.settings_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class MonitoringEventApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/monitoring/event', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
  }
}
class OnboardingPlatformIntegrateApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/onboarding/platform-integrate/{id}', 'POST', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class OnboardingPlatformIntegrationApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/onboarding/platform-integration/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async list(requestParameters) {
    const response = await this.request('/portal/form', 'GET', {}, {
      company_id: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.company_id
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/portal/form/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormAuthApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/portal/form-auth', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async options() {
    const response = await this.request('/portal/form-auth', 'OPTIONS', {}, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/portal/form-auth/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/portal/form-auth/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/portal/form-auth/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/portal/form-auth/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormAuthCreateWithoutOrderApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/portal/form-auth/{id}/create-without-order', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormAuthSendVerificationMailApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/portal/form-auth/{id}/send-verification-mail', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormProgressApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/portal/form-progress', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async options() {
    const response = await this.request('/portal/form-progress', 'OPTIONS', {}, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormProgressCreateIntentApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}/create-intent', 'POST', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormProgressCreateTicketApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}/create-ticket', 'POST', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormProgressExchangeCatalogApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async list(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}/exchange-catalog', 'GET', {
      id: requestParameters.id
    }, {
      q: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.q
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormProgressExchangeMethodsApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}/exchange-methods', 'GET', {
      id: requestParameters.id
    }, {
      country: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.country
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormProgressExchangePreviewApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}/exchange-preview', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormProgressExchangeVariantsApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}/exchange-variants', 'GET', {
      id: requestParameters.id
    }, {
      code: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.code
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormProgressExchangeWizardApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}/exchange-wizard', 'GET', {
      id: requestParameters.id
    }, {
      immutable_order_item: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.immutable_order_item
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormProgressShippingRouteApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}/shipping-route', 'GET', {
      id: requestParameters.id
    }, {
      shipping_route_id: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.shipping_route_id
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalFormProgressShippingRoutesApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async list(requestParameters) {
    const response = await this.request('/portal/form-progress/{id}/shipping-routes', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalGeoDataByCoordsApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/portal/geo-data-by-coords', 'GET', {}, {
      lang: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.lang,
      lat: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.lat,
      lng: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.lng
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalGeoDataByQueryApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/portal/geo-data-by-query', 'GET', {}, {
      city: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.city,
      country: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.country,
      house_number: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.house_number,
      lang: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.lang,
      postal_code: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.postal_code,
      street: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.street
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalNpsSurveyApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/portal/nps-survey', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async options() {
    const response = await this.request('/portal/nps-survey', 'OPTIONS', {}, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class PortalPlaceDetailApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/portal/place-detail', 'GET', {}, {
      place_id: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.place_id
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class ShippingPortalGeoDataByQueryApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/shipping-portal/geo-data-by-query', 'GET', {}, {
      city: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.city,
      country: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.country,
      house_number: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.house_number,
      lang: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.lang,
      postal_code: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.postal_code,
      street: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.street
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class ShippingRatingApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/shipping/{company_id}/rating/{shipping_id}/', 'GET', {
      company_id: requestParameters.company_id,
      shipping_id: requestParameters.shipping_id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/shipping/{company_id}/rating/{shipping_id}/', 'POST', {
      company_id: requestParameters.company_id,
      shipping_id: requestParameters.shipping_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping/{company_id}/rating/{shipping_id}/', 'PUT', {
      company_id: requestParameters.company_id,
      shipping_id: requestParameters.shipping_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping/{company_id}/rating/{shipping_id}/', 'PATCH', {
      company_id: requestParameters.company_id,
      shipping_id: requestParameters.shipping_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/shipping/{company_id}/rating/{shipping_id}/', 'OPTIONS', {
      company_id: requestParameters.company_id,
      shipping_id: requestParameters.shipping_id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class ShippingDropOffBranchApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/shipping/drop-off-branch/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class ShippingDropOffBranchNearestFromCenterApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async list(requestParameters) {
    const response = await this.request('/shipping/drop-off-branch/nearest-from-center', 'GET', {}, {
      country: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.country,
      lat: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.lat,
      lng: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.lng,
      shipping_providers: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.shipping_providers
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class ShippingProvidersConfigApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async list(requestParameters) {
    const response = await this.request('/shipping/providers/config', 'GET', {}, {
      include_internal: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.include_internal
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class TransportRatingApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/transport/{company_id}/rating/{shipping_id}/', 'GET', {
      company_id: requestParameters.company_id,
      shipping_id: requestParameters.shipping_id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/transport/{company_id}/rating/{shipping_id}/', 'POST', {
      company_id: requestParameters.company_id,
      shipping_id: requestParameters.shipping_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/transport/{company_id}/rating/{shipping_id}/', 'OPTIONS', {
      company_id: requestParameters.company_id,
      shipping_id: requestParameters.shipping_id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class TransportDropOffBranchNearestApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async list(requestParameters) {
    const response = await this.request('/transport/drop-off-branch-nearest', 'GET', {}, {
      lat: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.lat,
      lng: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.lng,
      shipping_providers: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.shipping_providers
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class TransportDropOffBranchApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async retrieve(requestParameters) {
    const response = await this.request('/transport/drop-off-branch/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class TransportFetchDropOffBranchesApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async list(requestParameters) {
    const response = await this.request('/transport/fetch-drop-off-branches', 'GET', {}, {
      lat: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.lat,
      lng: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.lng,
      shipping_providers: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.shipping_providers
    }, undefined);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class TransportMakeWebhookMyGlsInternationalTrackingNumberApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/transport/make-webhook/my-gls-international-tracking-number', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
  }
}
class TransportShippingRatingApi extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApi */ .SQ {
  async create(requestParameters) {
    const response = await this.request('/transport/shipping/rating', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new _base__WEBPACK_IMPORTED_MODULE_0__/* .JSONApiResponse */ .ko(response).value();
  }
}
class ApiClient extends _base__WEBPACK_IMPORTED_MODULE_0__/* .BaseApiClient */ .tJ {
  constructor(options) {
    super(options);
    this.AddressAddressApi = void 0;
    this.AuthAcceptInvitationApi = void 0;
    this.AuthEmailAvailableApi = void 0;
    this.AuthLoginApi = void 0;
    this.AuthPasswordResetApi = void 0;
    this.AuthPasswordSetApi = void 0;
    this.AuthRegisterApi = void 0;
    this.AuthRegisterValidateDetailsApi = void 0;
    this.AuthTwoFactorVerifyApi = void 0;
    this.BadgeBadgeReportCommentsApi = void 0;
    this.BadgeCanRetainBadgeApi = void 0;
    this.BillingStripeWebhookApi = void 0;
    this.ClientRatingCommentApi = void 0;
    this.ClientTicketApi = void 0;
    this.ClientTicketMessagesApi = void 0;
    this.ClientTicketProductCustomFieldTypesApi = void 0;
    this.ClientTicketProductsApi = void 0;
    this.ClientTicketUnsubscribeApi = void 0;
    this.CompanyCompanyApi = void 0;
    this.CompanyWebhookPipedriveMergeApi = void 0;
    this.FilesFileUploadRequestApi = void 0;
    this.FilesFileUploadRequestUploadedApi = void 0;
    this.FilesFilesApi = void 0;
    this.MarketplaceRemarketingSettingsApi = void 0;
    this.MarketplaceRemarketingCallRequestApi = void 0;
    this.MarketplaceRemarketingCreateVoucherApi = void 0;
    this.MonitoringEventApi = void 0;
    this.OnboardingPlatformIntegrateApi = void 0;
    this.OnboardingPlatformIntegrationApi = void 0;
    this.PortalFormApi = void 0;
    this.PortalFormAuthApi = void 0;
    this.PortalFormAuthCreateWithoutOrderApi = void 0;
    this.PortalFormAuthSendVerificationMailApi = void 0;
    this.PortalFormProgressApi = void 0;
    this.PortalFormProgressCreateIntentApi = void 0;
    this.PortalFormProgressCreateTicketApi = void 0;
    this.PortalFormProgressExchangeCatalogApi = void 0;
    this.PortalFormProgressExchangeMethodsApi = void 0;
    this.PortalFormProgressExchangePreviewApi = void 0;
    this.PortalFormProgressExchangeVariantsApi = void 0;
    this.PortalFormProgressExchangeWizardApi = void 0;
    this.PortalFormProgressShippingRouteApi = void 0;
    this.PortalFormProgressShippingRoutesApi = void 0;
    this.PortalGeoDataByCoordsApi = void 0;
    this.PortalGeoDataByQueryApi = void 0;
    this.PortalNpsSurveyApi = void 0;
    this.PortalPlaceDetailApi = void 0;
    this.ShippingPortalGeoDataByQueryApi = void 0;
    this.ShippingRatingApi = void 0;
    this.ShippingDropOffBranchApi = void 0;
    this.ShippingDropOffBranchNearestFromCenterApi = void 0;
    this.ShippingProvidersConfigApi = void 0;
    this.TransportRatingApi = void 0;
    this.TransportDropOffBranchNearestApi = void 0;
    this.TransportDropOffBranchApi = void 0;
    this.TransportFetchDropOffBranchesApi = void 0;
    this.TransportMakeWebhookMyGlsInternationalTrackingNumberApi = void 0;
    this.TransportShippingRatingApi = void 0;
    this.initApis();
  }
  initApis() {
    this.AddressAddressApi = new AddressAddressApi(this);
    this.AuthAcceptInvitationApi = new AuthAcceptInvitationApi(this);
    this.AuthEmailAvailableApi = new AuthEmailAvailableApi(this);
    this.AuthLoginApi = new AuthLoginApi(this);
    this.AuthPasswordResetApi = new AuthPasswordResetApi(this);
    this.AuthPasswordSetApi = new AuthPasswordSetApi(this);
    this.AuthRegisterApi = new AuthRegisterApi(this);
    this.AuthRegisterValidateDetailsApi = new AuthRegisterValidateDetailsApi(this);
    this.AuthTwoFactorVerifyApi = new AuthTwoFactorVerifyApi(this);
    this.BadgeBadgeReportCommentsApi = new BadgeBadgeReportCommentsApi(this);
    this.BadgeCanRetainBadgeApi = new BadgeCanRetainBadgeApi(this);
    this.BillingStripeWebhookApi = new BillingStripeWebhookApi(this);
    this.ClientRatingCommentApi = new ClientRatingCommentApi(this);
    this.ClientTicketApi = new ClientTicketApi(this);
    this.ClientTicketMessagesApi = new ClientTicketMessagesApi(this);
    this.ClientTicketProductCustomFieldTypesApi = new ClientTicketProductCustomFieldTypesApi(this);
    this.ClientTicketProductsApi = new ClientTicketProductsApi(this);
    this.ClientTicketUnsubscribeApi = new ClientTicketUnsubscribeApi(this);
    this.CompanyCompanyApi = new CompanyCompanyApi(this);
    this.CompanyWebhookPipedriveMergeApi = new CompanyWebhookPipedriveMergeApi(this);
    this.FilesFileUploadRequestApi = new FilesFileUploadRequestApi(this);
    this.FilesFileUploadRequestUploadedApi = new FilesFileUploadRequestUploadedApi(this);
    this.FilesFilesApi = new FilesFilesApi(this);
    this.MarketplaceRemarketingSettingsApi = new MarketplaceRemarketingSettingsApi(this);
    this.MarketplaceRemarketingCallRequestApi = new MarketplaceRemarketingCallRequestApi(this);
    this.MarketplaceRemarketingCreateVoucherApi = new MarketplaceRemarketingCreateVoucherApi(this);
    this.MonitoringEventApi = new MonitoringEventApi(this);
    this.OnboardingPlatformIntegrateApi = new OnboardingPlatformIntegrateApi(this);
    this.OnboardingPlatformIntegrationApi = new OnboardingPlatformIntegrationApi(this);
    this.PortalFormApi = new PortalFormApi(this);
    this.PortalFormAuthApi = new PortalFormAuthApi(this);
    this.PortalFormAuthCreateWithoutOrderApi = new PortalFormAuthCreateWithoutOrderApi(this);
    this.PortalFormAuthSendVerificationMailApi = new PortalFormAuthSendVerificationMailApi(this);
    this.PortalFormProgressApi = new PortalFormProgressApi(this);
    this.PortalFormProgressCreateIntentApi = new PortalFormProgressCreateIntentApi(this);
    this.PortalFormProgressCreateTicketApi = new PortalFormProgressCreateTicketApi(this);
    this.PortalFormProgressExchangeCatalogApi = new PortalFormProgressExchangeCatalogApi(this);
    this.PortalFormProgressExchangeMethodsApi = new PortalFormProgressExchangeMethodsApi(this);
    this.PortalFormProgressExchangePreviewApi = new PortalFormProgressExchangePreviewApi(this);
    this.PortalFormProgressExchangeVariantsApi = new PortalFormProgressExchangeVariantsApi(this);
    this.PortalFormProgressExchangeWizardApi = new PortalFormProgressExchangeWizardApi(this);
    this.PortalFormProgressShippingRouteApi = new PortalFormProgressShippingRouteApi(this);
    this.PortalFormProgressShippingRoutesApi = new PortalFormProgressShippingRoutesApi(this);
    this.PortalGeoDataByCoordsApi = new PortalGeoDataByCoordsApi(this);
    this.PortalGeoDataByQueryApi = new PortalGeoDataByQueryApi(this);
    this.PortalNpsSurveyApi = new PortalNpsSurveyApi(this);
    this.PortalPlaceDetailApi = new PortalPlaceDetailApi(this);
    this.ShippingPortalGeoDataByQueryApi = new ShippingPortalGeoDataByQueryApi(this);
    this.ShippingRatingApi = new ShippingRatingApi(this);
    this.ShippingDropOffBranchApi = new ShippingDropOffBranchApi(this);
    this.ShippingDropOffBranchNearestFromCenterApi = new ShippingDropOffBranchNearestFromCenterApi(this);
    this.ShippingProvidersConfigApi = new ShippingProvidersConfigApi(this);
    this.TransportRatingApi = new TransportRatingApi(this);
    this.TransportDropOffBranchNearestApi = new TransportDropOffBranchNearestApi(this);
    this.TransportDropOffBranchApi = new TransportDropOffBranchApi(this);
    this.TransportFetchDropOffBranchesApi = new TransportFetchDropOffBranchesApi(this);
    this.TransportMakeWebhookMyGlsInternationalTrackingNumberApi = new TransportMakeWebhookMyGlsInternationalTrackingNumberApi(this);
    this.TransportShippingRatingApi = new TransportShippingRatingApi(this);
  }
}

/***/ }),

/***/ 18883:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35443);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51145);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable class-methods-use-this */


class AddCsrfHeaderMiddleware {
  // eslint-disable-next-line class-methods-use-this
  async pre(context) {
    const cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A();
    context.init.headers = _objectSpread(_objectSpread({}, context.init.headers), {}, {
      'X-CSRFToken': cookies.get('csrftoken')
    });
    return context;
  }
}
class HandleErrorsMiddleware {
  async onError(context) {
    if (!context.response || context.response.status === 0) {
      ui__WEBPACK_IMPORTED_MODULE_0__/* .toast */ .oR.error(gettext("We couldn't connect to Retino servers. We'll keep trying but there may be a problem with your connection."));
    }
  }
  async post(_ref) {
    let {
      response
    } = _ref;
    if (response.type === 'error') {
      ui__WEBPACK_IMPORTED_MODULE_0__/* .toast */ .oR.error(gettext("We couldn't connect to Retino servers. We'll keep trying but there may be a problem with your connection."));
    } else if (response.status === 500) {
      ui__WEBPACK_IMPORTED_MODULE_0__/* .toast */ .oR.error(gettext('We were not able to process your request. Our developers have been informed.'));
    } else if (response.status >= 501) {
      ui__WEBPACK_IMPORTED_MODULE_0__/* .toast */ .oR.error(gettext('We were not able to process your request.'));
    }
  }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  AddCsrfHeaderMiddleware,
  HandleErrorsMiddleware
});

/***/ }),

/***/ 93893:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   OZ: () => (/* binding */ url)
/* harmony export */ });
/* unused harmony exports reverse, i18nUrl */
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isDevelopment = "production" === 'development';
const checkKeys = (pattern, params) => {
  Object.keys(params).forEach(key => {
    if (pattern.indexOf(":".concat(key)) < 0) {
      console.warn("Unknown parameter :".concat(key, " in pattern ").concat(pattern, ". (Maybe you wanted to pass <routes>.<route>.url instead of <routes>.<route>.)"));
    }
  });
};
const preserveEndingSlash = (pattern, reversed) => {
  const endingSlashRe = /\/$/;
  const shouldHave = endingSlashRe.test(pattern);
  const has = endingSlashRe.test(reversed);
  if (shouldHave && !has) {
    return "".concat(reversed, "/");
  }
  if (!shouldHave && has) {
    return reversed.slice(0, reversed.length - 1);
  }
  return reversed;
};
const reverse = function (pattern) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (isDevelopment) {
    checkKeys(pattern, params);
  }
  const reversed = pattern.replace(/\w*(:\w+\??)/g, (path, param) => {
    const key = param.replace(/[:?]/g, '');
    if (params[key] === undefined) {
      if (param.indexOf('?') < 0) {
        if (isDevelopment) {
          console.warn("Required parameter ".concat(key, " is missing for ").concat(pattern));
        }
        return path;
      }
      return '';
    }
    return path.replace(param, params[key]);
  }).replace(/\/\//, '/');
  return preserveEndingSlash(pattern, reversed);
};
function url(urlString) {
  let baseURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const fullUrl = baseURL + urlString;
  const result = reverseArgs => reverse(fullUrl, baseURL.includes(':lang') ? _objectSpread({
    lang: window.appState.lang
  }, reverseArgs) : reverseArgs);

  // Remove query params from the URL (because react-router won't work with them in app_index for example)
  result.url = fullUrl.split('?')[0];
  return result;
}
function i18nUrl(urlString) {
  return url(urlString, '/:lang');
}

/***/ }),

/***/ 98736:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function CardContent(_ref) {
  let {
    children
  } = _ref;
  const classes = ['px-4', 'py-5', 'sm:p-6'];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes.join(' ')
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CardContent);

/***/ }),

/***/ 66058:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function CardFooter(_ref) {
  let {
    children,
    gray
  } = _ref;
  const classes = ['card-footer', 'px-4', 'py-4', 'sm:px-6', 'rounded-b-lg'];
  if (gray) {
    classes.push('bg-gray-50');
  } else {
    classes.push('bg-white');
    classes.push('border-t', 'border-gray-200');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes.join(' ')
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CardFooter);

/***/ }),

/***/ 5376:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function CardHeader(_ref) {
  let {
    title,
    subtitle,
    children
  } = _ref;
  if (children && title) {
    throw Error('Specify either title or children!');
  }
  if (title) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "card-header border-b border-gray-200 px-4 py-5 font-medium sm:px-6"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "leading-6"
    }, title), subtitle && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "mt-1 text-sm font-normal text-gray-500"
    }, subtitle));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "card-header border-b border-gray-200 px-4 py-5 font-medium sm:px-6"
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CardHeader);

/***/ }),

/***/ 95680:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function DropdownGroup(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "py-1"
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DropdownGroup);

/***/ }),

/***/ 76356:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35443);



const DropdownItem = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((_ref, ref) => {
  let {
    icon,
    children,
    onClick,
    active,
    disabled,
    type = 'button'
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    ref: ref,
    type: type,
    role: "menuitem",
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("group flex w-full items-center whitespace-nowrap px-4 py-2 text-left text-sm", active && !disabled && 'bg-primary-700 text-white', disabled && !active && 'cursor-not-allowed text-gray-400', !active && !disabled && 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'),
    onClick: onClick
  }, icon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .In, {
    className: "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500",
    name: icon
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "contents"
  }, children));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DropdownItem);

/***/ }),

/***/ 31871:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35443);



function getBgColor(color) {
  switch (color) {
    case 'gray':
      return 'bg-gray-600';
    case 'indigo':
      return 'bg-indigo-600';
    case 'red':
      return 'bg-red-600';
    case 'yellow':
      return 'bg-yellow-600';
    case 'fuchsia':
      return 'bg-fuchsia-600';
    case 'violet':
      return 'bg-violet-600';
    case 'green':
      return 'bg-green-600';
    case 'blue':
      return 'bg-blue-600';
    case 'orange':
      return 'bg-orange-600';
    case 'sky':
      return 'bg-sky-600';
    default:
      return 'bg-gray-600';
  }
}
function FeedEvent(_ref) {
  let {
    icon,
    color,
    segmentColor,
    children,
    renderChildren = () => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .Segment */ .Y4, {
      color: segmentColor
    }, children),
    feedIconRingColor = 'ring-gray-100',
    // Default matches Segment's py-5 header; compact cards pass a smaller offset to stay aligned.
    feedIconOffset = 'mt-7'
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
    className: "feed-event"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative pb-5"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "feed-event-line absolute top-6 left-4 -ml-px h-full w-0.5 bg-gray-200",
    "aria-hidden": "true"
  }), icon ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative flex gap-2 md:gap-6"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex h-8 w-8 items-center justify-center rounded-full ring-8 ".concat(feedIconRingColor, " ").concat(feedIconOffset), getBgColor(color))
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .In, {
    solid: true,
    name: icon,
    color: "white",
    fitted: true
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "min-w-0 flex-1"
  }, renderChildren(children))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative flex items-center gap-2 md:gap-6"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative px-3"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "h-2 w-2 rounded-full bg-gray-300 ring-8 ".concat(feedIconRingColor, " flex items-center justify-center")
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "min-w-0 flex-1 py-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-sm text-gray-500"
  }, children)))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FeedEvent);

/***/ }),

/***/ 81723:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  D0: () => (/* binding */ Field),
  cG: () => (/* binding */ FormCheckbox),
  ZQ: () => (/* binding */ FormInput),
  GC: () => (/* binding */ FormMultiselect),
  Mi: () => (/* binding */ FormRadio),
  wN: () => (/* binding */ FormRadioPanel),
  sM: () => (/* binding */ FormRichText),
  FX: () => (/* binding */ FormSelect),
  hg: () => (/* binding */ FormTextarea)
});

// UNUSED EXPORTS: default, makeFormField

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/linkify-react/dist/linkify-react.es.js + 1 modules
var linkify_react_es = __webpack_require__(58348);
// EXTERNAL MODULE: ./react/ui/utils.ts
var utils = __webpack_require__(53173);
// EXTERNAL MODULE: ./react/ui/form/checkbox/Checkbox.tsx
var Checkbox = __webpack_require__(95520);
// EXTERNAL MODULE: ./react/ui/form/input/Input.tsx
var Input = __webpack_require__(31496);
// EXTERNAL MODULE: ./react/ui/form/multiselect/Multiselect.tsx
var Multiselect = __webpack_require__(35688);
// EXTERNAL MODULE: ./react/ui/form/radio/Radio.tsx
var Radio = __webpack_require__(51304);
// EXTERNAL MODULE: ./react/ui/form/radioPanel/RadioPanel.tsx
var RadioPanel = __webpack_require__(43320);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(46942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./react/ui/rich-text-editor/RichTextEditor.tsx + 1 modules
var RichTextEditor = __webpack_require__(41379);
;// ./react/ui/form/richtext/RichText.tsx




function RichText(_ref) {
  let {
    id,
    name,
    error,
    placeholder,
    value,
    autofocus,
    onChange,
    className = 'border'
  } = _ref;
  const internalId = (0,utils/* useId */.B)();
  if (!name) {
    name = "richtext-".concat(internalId);
  }
  if (!id) {
    id = "".concat(name, "__id");
  }
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()('relative', className)
  }, /*#__PURE__*/react.createElement(RichTextEditor/* default */.A, {
    initialValue: value,
    autofocus: autofocus,
    onChange: onChange,
    placeholder: placeholder
  }), error && /*#__PURE__*/react.createElement("div", {
    className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
  }, /*#__PURE__*/react.createElement("svg", {
    className: "h-5 w-5 text-red-500",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }))));
}
/* harmony default export */ const richtext_RichText = (RichText);
// EXTERNAL MODULE: ./react/ui/form/select/Select.tsx
var Select = __webpack_require__(44874);
// EXTERNAL MODULE: ./react/ui/form/textarea/Textarea.tsx
var Textarea = __webpack_require__(97670);
;// ./react/ui/form/formFields.tsx
const _excluded = ["id", "name", "htmlFor"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }











function Field(_ref) {
  let {
    label,
    cornerHint,
    id,
    htmlFor,
    error,
    helpText,
    children,
    showError = true
  } = _ref;
  return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "flex justify-between"
  }, label ? /*#__PURE__*/react.createElement("label", {
    htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : id,
    className: "block text-sm font-medium text-gray-700"
  }, label) : /*#__PURE__*/react.createElement("span", null), /*#__PURE__*/react.createElement("span", {
    className: "text-sm text-gray-500"
  }, cornerHint)), /*#__PURE__*/react.createElement("div", {
    className: "mt-1"
  }, children), error && showError && /*#__PURE__*/react.createElement("p", {
    className: "mt-2 text-sm text-red-600"
  }, /*#__PURE__*/react.createElement(linkify_react_es/* default */.A, {
    tagName: "span",
    options: {
      className: 'text-red-700 hover:text-red-800',
      target: '_blank'
    }
  }, error)), helpText && !error && /*#__PURE__*/react.createElement("p", {
    className: "mt-2 text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement(linkify_react_es/* default */.A, {
    tagName: "span",
    options: {
      className: 'text-indigo-600 hover:text-indigo-800',
      target: '_blank'
    }
  }, helpText)));
}
function makeFormField(Component) {
  return function (_ref2) {
    let {
        id,
        name,
        htmlFor
      } = _ref2,
      rest = _objectWithoutProperties(_ref2, _excluded);
    const internalId = (0,utils/* useId */.B)();
    if (!id) {
      id = "form-control-".concat(internalId);
    }
    if (!name) {
      name = id;
    }
    if (!htmlFor) {
      htmlFor = id;
    }
    const newProps = _objectSpread({
      id,
      name,
      htmlFor
    }, rest);
    return /*#__PURE__*/react.createElement(Field, newProps, /*#__PURE__*/react.createElement(Component, newProps));
  };
}
const FormInput = makeFormField(Input/* default */.A);
const FormTextarea = makeFormField(Textarea/* default */.A);
const FormRichText = makeFormField(richtext_RichText);
const FormSelect = makeFormField(Select/* default */.A);
const FormMultiselect = Multiselect/* default */.A;
const FormCheckbox = Checkbox/* default */.A;
const FormRadio = Radio/* default */.A;
const FormRadioPanel = RadioPanel/* default */.A;
/* harmony default export */ const formFields = ({
  Field,
  FormInput,
  FormCheckbox,
  FormSelect,
  FormMultiselect,
  FormTextarea,
  FormRichText,
  FormRadio,
  FormRadioPanel
});

/***/ }),

/***/ 35688:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92756);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41906);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35443);
/* harmony import */ var _SelectOption__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82748);





// todo tailwind disabled, readonly

function Multiselect(_ref) {
  let {
    id,
    label,
    choices,
    value,
    placeholder = gettext('Select...'),
    helpText,
    error,
    minWidth = undefined,
    onChange,
    checkPosition = 'right',
    position = 'bottom left'
  } = _ref;
  const toggleValue = itemValue => onChange((0,helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .toggleItem */ .g6)(value, itemValue));
  const handleLabelRemoveClick = itemValue => e => {
    e.preventDefault();
    onChange(value.filter(item => item !== itemValue));
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Listbox */ .W, {
    as: "div",
    id: id,
    value: value,
    onChange: toggleValue
  }, _ref2 => {
    let {
      open
    } = _ref2;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Listbox */ .W.Label, {
      className: "block text-sm font-medium text-gray-700",
      style: {
        minWidth
      }
    }, label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "relative mt-1"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .Popup */ .zD, {
      on: "click",
      fluid: true,
      className: "w-full rounded-md bg-white shadow-lg",
      position: position,
      open: open,
      trigger: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Listbox */ .W.Button, {
        className: "relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        className: "-mt-1 block"
      }, value && value.map(itemValue => {
        var _choices$find;
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
          className: "mt-1 mr-1 inline-block"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .Label */ .JU, {
          onRemove: handleLabelRemoveClick(itemValue)
        }, choices === null || choices === void 0 || (_choices$find = choices.find(item => item.value === itemValue)) === null || _choices$find === void 0 ? void 0 : _choices$find.label));
      }), (!value || value.length === 0) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        className: "mt-1 inline-block text-gray-300"
      }, placeholder)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        className: "h-5 w-5 text-gray-400",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        d: "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
        clipRule: "evenodd"
      }))))
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Listbox */ .W.Options, {
      className: "max-h-60 w-full overflow-auto rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
    }, choices === null || choices === void 0 ? void 0 : choices.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Listbox */ .W.Option, {
      value: item.value,
      key: item.label
    }, _ref3 => {
      let {
        selected,
        active
      } = _ref3;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SelectOption__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A, {
        selected: selected,
        active: active,
        checkPosition: checkPosition,
        label: item.label
      });
    })))), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
      className: "mt-2 text-sm text-red-600"
    }, error), helpText && !error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
      className: "mt-2 text-sm text-gray-500"
    }, helpText)));
  });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Multiselect);

/***/ }),

/***/ 51304:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53173);


function Radio(_ref) {
  let {
    name,
    id,
    label,
    helpText,
    value,
    classNames = classes => classes,
    onChange,
    error
  } = _ref;
  const internalId = (0,ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .useId */ .B)();
  const inputClasses = ['focus:ring-indigo-500', 'h-4', 'w-4', 'text-indigo-600', 'border'];
  const labelClasses = ['font-medium'];
  if (!name) {
    name = "radio-".concat(internalId);
  }
  if (!id) {
    id = "".concat(name, "__id");
  }
  if (error) {
    inputClasses.push('border-red-600');
    labelClasses.push('text-red-600');
  } else {
    inputClasses.push('border-gray-300');
    labelClasses.push('text-gray-700');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative flex items-start"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex h-5 items-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", {
    id: id,
    name: name,
    value: value ? 'true' : undefined,
    checked: value,
    onChange: onChange,
    type: "radio",
    className: classNames(inputClasses.flatMap(cls => cls.split(' '))).join(' ')
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "ml-3 text-sm"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
    htmlFor: id,
    className: labelClasses.join(' ')
  }, label), helpText && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "text-gray-500"
  }, helpText)));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Radio);

/***/ }),

/***/ 97670:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35443);
/* harmony import */ var ui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53173);



function Textarea(_ref) {
  let {
    id,
    name,
    icon,
    required = false,
    value = '',
    rows = 3,
    placeholder,
    autoFocus,
    error,
    onChange
  } = _ref;
  const internalId = (0,ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .useId */ .B)();
  if (!name) {
    name = "textarea-".concat(internalId);
  }
  if (!id) {
    id = "".concat(name, "__id");
  }
  const helpTextId = "".concat(id, "__description");
  const inputClasses = ['shadow-sm', 'block', 'w-full', 'sm:text-sm', 'rounded-md', 'placeholder-gray-300', 'text-gray-900'];
  if (error) {
    inputClasses.push('border-red-300', 'text-red-900', 'placeholder-red-300', 'focus:outline-none', 'focus:ring-red-500', 'focus:border-red-500');
  } else {
    inputClasses.push('focus:ring-indigo-500', 'focus:border-indigo-500', 'border-gray-300');
  }
  if (icon) {
    inputClasses.push('pl-10');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative flex-grow"
  }, icon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    name: icon,
    className: "h-5 w-5 text-gray-400"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("textarea", {
    autoFocus: autoFocus,
    name: name,
    id: id,
    placeholder: placeholder,
    value: value,
    required: required,
    onChange: e => onChange(e.target.value),
    "aria-describedby": helpTextId,
    rows: rows,
    className: inputClasses.join(' ')
  }), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    className: "h-5 w-5 text-red-500",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Textarea);

/***/ }),

/***/ 59910:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function ModalContent(_ref) {
  let {
    children,
    gray
  } = _ref;
  const classes = ['px-4', 'py-5', 'sm:p-6', 'text-gray-500', 'text-sm'];
  if (gray) {
    classes.push('bg-gray-50');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes.join(' ')
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalContent);

/***/ }),

/***/ 81972:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function ModalFooter(_ref) {
  let {
    children,
    gray = true
  } = _ref;
  const classes = ['card-footer', 'px-4', 'py-4', 'sm:px-6', 'rounded-b-md'];
  if (gray) {
    classes.push('bg-gray-50');
  } else {
    classes.push('bg-white');
    classes.push('border-t', 'border-gray-200');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes.join(' ')
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalFooter);

/***/ }),

/***/ 91446:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function ModalHeader(_ref) {
  let {
    children,
    title,
    subtitle
  } = _ref;
  if (children && title) {
    throw Error('Specify either title or children!');
  }

  // Modal points aria-labelledby at this id, so a header is what names the dialog.
  if (title) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "modal-header border-b border-gray-200 px-4 py-5 font-medium sm:px-6"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "leading-6",
      id: "modal-headline"
    }, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "mt-1 text-sm font-normal text-gray-500"
    }, subtitle));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "modal-header border-b border-gray-200 px-4 py-5 font-medium text-gray-900 sm:px-6",
    id: "modal-headline"
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalHeader);

/***/ }),

/***/ 95971:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40961);


const Portal = _ref => {
  let {
    children
  } = _ref;
  // #react-modal-container is located in app_base.html in the body element
  const portalContainer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(document.getElementById('react-portal-container'));
  return /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, portalContainer.current);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Portal);

/***/ }),

/***/ 41379:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ rich_text_editor_RichTextEditor)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(65848);
// EXTERNAL MODULE: ./react/helpers/utils.ts
var utils = __webpack_require__(41906);
// EXTERNAL MODULE: ./react/ui/icon/Icon.tsx + 454 modules
var Icon = __webpack_require__(53623);
// EXTERNAL MODULE: ./node_modules/@tinymce/tinymce-react/lib/es2015/main/ts/index.js + 5 modules
var ts = __webpack_require__(78002);
// EXTERNAL MODULE: ./node_modules/tinymce/tinymce.js
var tinymce = __webpack_require__(75199);
// EXTERNAL MODULE: ./node_modules/tinymce/models/dom/model.js
var model = __webpack_require__(9595);
// EXTERNAL MODULE: ./node_modules/tinymce/themes/silver/index.js
var silver = __webpack_require__(16075);
// EXTERNAL MODULE: ./node_modules/tinymce/icons/default/index.js
var icons_default = __webpack_require__(67741);
// EXTERNAL MODULE: ./node_modules/tinymce/plugins/autolink/index.js
var autolink = __webpack_require__(12205);
// EXTERNAL MODULE: ./node_modules/tinymce/plugins/autoresize/index.js
var autoresize = __webpack_require__(45669);
// EXTERNAL MODULE: ./node_modules/tinymce/plugins/help/index.js
var help = __webpack_require__(32073);
// EXTERNAL MODULE: ./node_modules/tinymce/plugins/link/index.js
var plugins_link = __webpack_require__(20378);
// EXTERNAL MODULE: ./node_modules/tinymce/plugins/lists/index.js
var lists = __webpack_require__(55775);
;// ./react/ui/rich-text-editor/BundledEditor.jsx
const _excluded = ["init"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable import/no-webpack-loader-syntax */



// TinyMCE so the global var exists
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars

// DOM model

// Theme

// Toolbar icons


// importing the plugin js.
// if you use a plugin that is not listed here the editor will fail to load





function BundledEditor(props) {
  const {
      init
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/react.createElement(ts/* Editor */.K, _extends({
    init: _objectSpread(_objectSpread({}, init), {}, {
      language: window.appState.lang,
      skin_url: "".concat(window.appState.baseStaticUrl, "tinymce/retino-skin"),
      content_css: false,
      language_url: "".concat(window.appState.baseStaticUrl, "tinymce/langs/").concat(window.appState.lang, ".js"),
      base_url: "".concat(window.appState.baseStaticUrl, "tinymce")
    })
  }, rest));
}
// EXTERNAL MODULE: ./react/ui/rich-text-editor/utils.ts
var rich_text_editor_utils = __webpack_require__(42316);
;// ./react/ui/rich-text-editor/RichTextEditor.tsx






const MIN_HEIGHT = 200;
function RichTextEditor(_ref) {
  let {
    id,
    initialValue,
    autofocus,
    placeholder,
    onChange,
    onKeyDown,
    onInit,
    customActions,
    autocompleters,
    onLoad,
    onDrop,
    onPaste
  } = _ref;
  const [initialValueInner, setInitialValueInner] = (0,react.useState)(initialValue);
  const editorRef = (0,react.useRef)(null);
  const isReadyRef = (0,react.useRef)(false);
  const toolbarCustomButtons = () => {
    var _customActions$map;
    const items = (_customActions$map = customActions === null || customActions === void 0 ? void 0 : customActions.map(action => action.key)) !== null && _customActions$map !== void 0 ? _customActions$map : [];
    if (items.length === 0) return '';
    return "".concat(items.join(' '), " | ");
  };
  const getInitialValue = () => {
    if (!initialValueInner) return '';
    return (0,utils/* containsHTMLTags */.uU)(initialValueInner) ? (0,rich_text_editor_utils/* preProcess */.H)(initialValueInner) : (0,utils/* nl2p */.hW)(initialValueInner);
  };
  (0,react.useEffect)(() => {
    if (initialValueInner === undefined || initialValueInner === null) {
      setInitialValueInner(initialValue);
    }
  }, [initialValue]);
  return /*#__PURE__*/react.createElement(BundledEditor, {
    id: id,
    tinymceScriptSrc: "".concat(window.appState.baseStaticUrl, "tinymce/tinymce.min.js"),
    initialValue: getInitialValue(),
    onSetContent: e => {
      if (!isReadyRef.current) return;
      onChange((0,rich_text_editor_utils/* postProcess */.g)(e.target.getContent()));
    },
    onChange: e => {
      onChange((0,rich_text_editor_utils/* postProcess */.g)(e.target.getContent()));
    },
    onInput: (_e, editor) => {
      onChange((0,rich_text_editor_utils/* postProcess */.g)(editor.getContent()));
    },
    onKeyDown: onKeyDown,
    onInit: onInit,
    onDrop: onDrop,
    onPaste: (event, editor) => {
      var _event$clipboardData, _event$clipboardData2;
      if (!event.clipboardData) return;
      if ((_event$clipboardData = event.clipboardData) !== null && _event$clipboardData !== void 0 && _event$clipboardData.getData('text/html')) return;

      // If the clipboard data contains plain text, keep the number of newlines
      const text = (_event$clipboardData2 = event.clipboardData) === null || _event$clipboardData2 === void 0 ? void 0 : _event$clipboardData2.getData('text/plain');
      if (text && text.length > 0 && !(0,utils/* containsHTMLTags */.uU)(text)) {
        editor.execCommand('mceInsertContent', false, text.replace(/\n{2,}/g, match => "\n".concat(Array(match.length - 1).fill('<p></p>').join(''))));
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
      }
      onPaste === null || onPaste === void 0 || onPaste(event);
    },
    init: {
      // called after the react wrapper's own init setContent, so content
      // normalization during mount never reaches onChange
      init_instance_callback: () => {
        isReadyRef.current = true;
      },
      min_height: MIN_HEIGHT,
      autoresize_bottom_margin: 0,
      menubar: false,
      auto_focus: autofocus ? true : undefined,
      placeholder,
      plugins: ['autoresize', 'autolink', 'lists', 'link'],
      toolbar: "bold italic forecolor |\n          alignleft aligncenter alignright alignjustify |\n          link | bullist numlist outdent indent | removeformat |\n          ".concat(toolbarCustomButtons()),
      setup: editor => {
        editorRef.current = editor;
        // autoresize plugin misses late reflows (webfont load) and caches its
        // last size, so mceAutoResize is a no-op; set the height directly
        editor.on('init', () => {
          const doc = editor.getDoc();
          if (!doc) return;
          const observer = new ResizeObserver(() => {
            const container = editor.getContainer();
            const contentArea = editor.getContentAreaContainer();
            if (!container || !contentArea) return;
            const chromeHeight = container.offsetHeight - contentArea.offsetHeight;
            const total = Math.max(doc.documentElement.offsetHeight + chromeHeight, MIN_HEIGHT);
            if (Math.abs(container.offsetHeight - total) > 1) {
              container.style.height = "".concat(total, "px");
            }
          });
          observer.observe(doc.documentElement);
          editor.on('remove', () => observer.disconnect());
        });
        customActions === null || customActions === void 0 || customActions.forEach(action => {
          editor.ui.registry.addIcon(action.icon, server_browser.renderToString( /*#__PURE__*/react.createElement(Icon/* default */.Ay$, {
            name: action.icon,
            className: "h-5 w-5 fill-none"
          })));
          editor.ui.registry.addButton(action.key, {
            icon: action.icon,
            tooltip: action.label,
            onAction: () => action.onClick()
          });
        });
        autocompleters === null || autocompleters === void 0 || autocompleters.forEach(ac => {
          var _ac$minChars;
          editor.ui.registry.addAutocompleter(ac.id, {
            trigger: ac.trigger,
            minChars: (_ac$minChars = ac.minChars) !== null && _ac$minChars !== void 0 ? _ac$minChars : 0,
            columns: 1,
            fetch: async pattern => {
              const items = await ac.fetch(pattern);
              return items.map(item => ({
                value: item.value,
                text: item.text,
                meta: item.meta
              }));
            },
            onAction: (autocompleteApi, rng, value, meta) => {
              editor.selection.setRng(rng);
              editor.execCommand('Delete');
              ac.onAction({
                value,
                text: '',
                meta
              }, editor);
              autocompleteApi.hide();
            }
          });
        });
        if (onLoad) {
          const computePaddingBottom = () => {
            const body = editor.getBody();
            const cs = getComputedStyle(body);
            if (editor.container && body.offsetHeight > 0) {
              body.style.paddingBottom = "".concat(Math.max(MIN_HEIGHT - editor.container.getElementsByClassName('tox-editor-header')[0].offsetHeight - (body.offsetHeight - parseFloat(cs.paddingBottom)), 0), "px");
            }
          };
          const firstResizeHandler = () => {
            onLoad();
            computePaddingBottom();
            editor.off('ResizeEditor', firstResizeHandler);
          };
          editor.on('ResizeEditor', firstResizeHandler);
          editor.on('input', () => {
            computePaddingBottom();
          });
          editor.on('setcontent', () => {
            computePaddingBottom();
          });
        }
      },
      content_style: "\n            body::before { cursor: text; }\n            body {\n              font-family: \"Inter var\",ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";\n              margin: 1rem;\n              line-height: 1.4;\n            }\n            ul,ol { list-style-position: inside; padding-inline-start: 0 }\n            ul ul { list-style-type: disc; }\n            ul ul,ol ol { padding-left: 1rem; }\n            a { color: #4f46e5; text-decoration: none; }\n            a:hover { color: #3730a3; }\n            p { margin: 0; }",
      branding: false,
      statusbar: false,
      font_css: "".concat(window.appState.baseStaticUrl, "fonts/inter/inter.css"),
      indentation: '32px',
      contextmenu: '',
      browser_spellcheck: true
    }
  });
}
/* harmony default export */ const rich_text_editor_RichTextEditor = (RichTextEditor);

/***/ }),

/***/ 42316:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: () => (/* binding */ preProcess),
/* harmony export */   g: () => (/* binding */ postProcess)
/* harmony export */ });
const preProcess = html => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const leftAligns = doc.querySelectorAll('.text-left');
  leftAligns.forEach(leftAlign => {
    leftAlign.setAttribute('style', 'text-align: left;');
  });
  const centerAligns = doc.querySelectorAll('.text-center');
  centerAligns.forEach(centerAlign => {
    centerAlign.setAttribute('style', 'text-align: center;');
  });
  const rightAligns = doc.querySelectorAll('.text-right');
  rightAligns.forEach(rightAlign => {
    rightAlign.setAttribute('style', 'text-align: right;');
  });
  const justifyAligns = doc.querySelectorAll('.text-justify');
  justifyAligns.forEach(justifyAlign => {
    justifyAlign.setAttribute('style', 'text-align: justify;');
  });
  const underlines = doc.querySelectorAll('.underline');
  underlines.forEach(underline => {
    underline.setAttribute('style', 'text-decoration: underline;');
  });
  const paddings = doc.querySelectorAll('.pl-8, .pl-16, .pl-24');
  paddings.forEach(padding => {
    if (padding instanceof HTMLElement) {
      let paddingLeft = '0px';
      if (padding.classList.contains('pl-8')) {
        paddingLeft = '32px';
      } else if (padding.classList.contains('pl-16')) {
        paddingLeft = '64px';
      } else if (padding.classList.contains('pl-24')) {
        paddingLeft = '96px';
      }
      padding.setAttribute('style', "padding-left: ".concat(paddingLeft, ";"));
    }
  });
  return doc.body.innerHTML;
};
const postProcess = html => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const bolds = doc.querySelectorAll('strong, b');
  bolds.forEach(bold => {
    bold.classList.add('font-bold');
  });
  const links = doc.querySelectorAll('a');
  links.forEach(link => {
    link.classList.add('text-indigo-600', 'hover:text-indigo-800');
  });
  const uls = doc.querySelectorAll('ul');
  uls.forEach(ul => {
    ul.classList.add('list-disc', 'list-inside');
    const nestedUls = ul.querySelectorAll('ul');
    nestedUls.forEach(nestedUl => {
      nestedUl.classList.add('pl-4');
    });
  });
  const ols = doc.querySelectorAll('ol');
  ols.forEach(ol => {
    ol.classList.add('list-decimal', 'list-inside');
    const nestedOls = ol.querySelectorAll('ol');
    nestedOls.forEach(nestedOl => {
      nestedOl.classList.add('pl-4');
    });
  });
  const listNones = doc.querySelectorAll('[style="list-style-type: none;"]');
  listNones.forEach(listNone => {
    listNone.classList.add('list-none');
  });
  const leftAligns = doc.querySelectorAll('[style="text-align: left;"]');
  leftAligns.forEach(leftAlign => {
    leftAlign.classList.add('text-left');
  });
  const centerAligns = doc.querySelectorAll('[style="text-align: center;"]');
  centerAligns.forEach(centerAlign => {
    centerAlign.classList.add('text-center');
  });
  const rightAligns = doc.querySelectorAll('[style="text-align: right;"]');
  rightAligns.forEach(rightAlign => {
    rightAlign.classList.add('text-right');
  });
  const justifyAligns = doc.querySelectorAll('[style="text-align: justify;"]');
  justifyAligns.forEach(justifyAlign => {
    justifyAlign.classList.add('text-justify');
  });
  const paddings = doc.querySelectorAll('[style^="padding-left:"]');
  paddings.forEach(padding => {
    if (padding instanceof HTMLElement) {
      const paddingLeft = padding.style.paddingLeft;
      const paddingLeftValue = paddingLeft ? parseInt(paddingLeft.replace('px', ''), 10) : 0;
      if (paddingLeftValue === 32) {
        padding.classList.add('pl-8');
      } else if (paddingLeftValue === 64) {
        padding.classList.add('pl-16');
      } else if (paddingLeftValue >= 96) {
        padding.classList.add('pl-24');
      }
    }
  });
  const headings = doc.querySelectorAll('h1, h2, h3, h4, h5, h6');
  headings.forEach(heading => {
    if (heading instanceof HTMLElement) {
      if (heading.tagName === 'H1') {
        heading.classList.add('text-2xl', 'font-bold');
      } else if (heading.tagName === 'H2') {
        heading.classList.add('text-xl', 'font-bold');
      } else if (heading.tagName === 'H3') {
        heading.classList.add('text-lg', 'font-bold');
      } else if (heading.tagName === 'H4') {
        heading.classList.add('text-base', 'font-bold');
      } else if (heading.tagName === 'H5') {
        heading.classList.add('text-sm', 'font-bold');
      } else if (heading.tagName === 'H6') {
        heading.classList.add('text-xs', 'font-bold');
      }
    }
  });
  const underlines = doc.querySelectorAll('[style="text-decoration: underline;"]');
  underlines.forEach(underline => {
    underline.classList.add('underline');
  });
  const italics = doc.querySelectorAll('em, address');
  italics.forEach(italic => {
    italic.classList.add('italic');
  });

  // remove empty paragraphs from the beginning
  while (doc.body.children.length > 0 && doc.body.children[0] instanceof HTMLElement && (!doc.body.children[0].textContent || doc.body.children[0].textContent.trim() === '')) {
    doc.body.children[0].remove();
  }

  // remove empty paragraphs from the end
  for (let i = doc.body.children.length - 1; i >= 0; i -= 1) {
    const child = doc.body.children[i];
    if (child instanceof HTMLElement) {
      if (!child.textContent || child.textContent.trim() === '') {
        child.remove();
      } else {
        break;
      }
    }
  }
  const moveTagsOutsideBrackets = htmlContent => htmlContent.replace(/\[\[([\s\S]*?)\]\]/g, (match, content) => {
    // Extract any HTML tags from the content
    const tags = content.match(/<\/?[^>]+>/g) || [];
    const strippedContent = content.replace(/<\/?[^>]+>/g, '');

    // Reconstruct with tags outside the brackets
    const beforeTags = tags.filter(tag => !tag.startsWith('</')).join('');
    const afterTags = tags.filter(tag => tag.startsWith('</')).join('');
    return "".concat(beforeTags, "[[").concat(strippedContent, "]]").concat(afterTags);
  });

  // Process the innerHTML of the document body
  doc.body.innerHTML = moveTagsOutsideBrackets(doc.body.innerHTML);
  return doc.body.innerHTML;
};

/***/ }),

/***/ 10189:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function TableBody(_ref) {
  let {
    children = null
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("tbody", {
    className: "divide-y divide-gray-200 bg-white"
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TableBody);

/***/ }),

/***/ 48817:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84976);


function TableCell(_ref) {
  let {
    id,
    collapsing = false,
    thin = false,
    stackable = true,
    onMouseEnter,
    onMouseLeave,
    textAlign = 'left',
    wrap = false,
    children = '',
    href,
    colSpan,
    onClick,
    verticalAlign
  } = _ref;
  const classNames = ['text-sm', 'text-gray-600', 'relative'];
  if (wrap) {
    classNames.push('whitespace-normal');
  } else {
    classNames.push('whitespace-nowrap');
  }
  if (thin) {
    classNames.push('px-3', 'py-4');
  } else {
    classNames.push('px-6', 'py-4');
  }
  if (stackable) {
    classNames.push('md:table-cell', 'block');
  } else {
    classNames.push('table-cell');
  }
  if (textAlign === 'right') {
    classNames.push('text-right');
  } else if (textAlign === 'center') {
    classNames.push('text-center');
  } else {
    classNames.push('text-left');
  }
  if (collapsing) {
    classNames.push('w-px');
  }
  switch (verticalAlign) {
    case 'top':
      classNames.push('align-top');
      break;
    default:
    case 'middle':
      classNames.push('align-middle');
      break;
    case 'bottom':
      classNames.push('align-bottom');
      break;
    case 'baseline':
      classNames.push('align-baseline');
      break;
  }
  if (onClick) {
    classNames.push('cursor-pointer');
  }
  if (href) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .N_, {
      id: id,
      to: href,
      className: classNames.join(' '),
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, children);
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("td", {
    id: id,
    className: classNames.join(' '),
    colSpan: colSpan,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TableCell);

/***/ }),

/***/ 75812:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function TableFooter(_ref) {
  let {
    children = null
  } = _ref;
  const classes = ['divide-y', 'divide-gray-200'];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("tfoot", {
    className: classes.join(' ')
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TableFooter);

/***/ }),

/***/ 31207:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function TableHead(_ref) {
  let {
    white,
    children
  } = _ref;
  const classes = [];
  if (white) {
    classes.push('bg-white');
  } else {
    classes.push('bg-gray-50');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("thead", {
    className: classes.join(' ')
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TableHead);

/***/ }),

/***/ 16531:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function TableHeadCell(_ref) {
  let {
    collapsing,
    thin,
    children,
    textAlign = 'left',
    stackable = true,
    colSpan
  } = _ref;
  const classNames = ['text-left', 'text-xs', 'font-medium', 'text-gray-600', 'uppercase', 'tracking-wider', 'whitespace-nowrap'];
  if (thin) {
    classNames.push('px-3', 'py-3');
  } else {
    classNames.push('px-6', 'py-3');
  }
  if (stackable) {
    classNames.push('md:table-cell', 'hidden');
  }
  switch (textAlign) {
    case 'left':
      classNames.push('text-left');
      break;
    case 'center':
      classNames.push('text-center');
      break;
    case 'right':
      classNames.push('text-right');
      break;
    default:
      break;
  }
  if (collapsing) {
    classNames.push('max-w-min');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("th", {
    scope: "col",
    className: classNames.join(' '),
    colSpan: colSpan
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TableHeadCell);

/***/ }),

/***/ 41509:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function TableRow(_ref) {
  let {
    id,
    selectable = false,
    negative = false,
    warning = false,
    color,
    children = null,
    onClick
  } = _ref;
  const classes = [];
  if (color) {
    classes.push(color);
  } else if (negative) {
    classes.push('bg-red-50');
  } else if (warning) {
    classes.push('bg-orange-50');
  }
  if (selectable) {
    classes.push('hover:bg-gray-50', 'cursor-pointer');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("tr", {
    id: id,
    className: classes.join(' '),
    onClick: onClick
  }, children);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TableRow);

/***/ }),

/***/ 34161:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ toast_ToastContainer)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js + 14 modules
var mobxreact_esm = __webpack_require__(44015);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(60990);
// EXTERNAL MODULE: ./react/ui/index.ts + 3 modules
var ui = __webpack_require__(35443);
;// ./react/ui/toast/ToastMessage.tsx




const OPEN_TIME = 5000;
function ToastMessage(_ref) {
  let {
    reducedToast,
    onClose
  } = _ref;
  const [isShown, setIsShown] = (0,react.useState)(true);
  (0,react.useEffect)(() => {
    setTimeout(() => setIsShown(false), OPEN_TIME);
  }, []);
  return /*#__PURE__*/react.createElement(transition/* Transition */.e, {
    appear: true,
    show: isShown,
    enter: "transform ease-out duration-300 transition",
    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
    leave: "transform ease-in duration-100 transition",
    leaveFrom: "opacity-100 translate-x-0",
    leaveTo: "opacity-0 translate-x-2",
    afterLeave: onClose,
    className: "pointer-events-auto mb-3 w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-start"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex-shrink-0"
  }, reducedToast.toast.type === 'success' && /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "check-circle",
    color: "green"
  }), reducedToast.toast.type === 'error' && /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "x-circle",
    color: "red"
  }), reducedToast.toast.type === 'warning' && /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "exclamation-circle",
    color: "yellow"
  }), reducedToast.toast.type === 'info' && /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "information-circle",
    color: "blue"
  })), /*#__PURE__*/react.createElement("div", {
    className: "ml-3 w-0 flex-1 pt-0.5"
  }, reducedToast.toast.title && /*#__PURE__*/react.createElement("div", {
    className: "flex"
  }, reducedToast.count > 1 && /*#__PURE__*/react.createElement("span", {
    className: "mr-1 text-sm text-gray-700"
  }, reducedToast.count, "\xD7"), /*#__PURE__*/react.createElement("p", {
    className: "text-sm font-medium text-gray-900"
  }, reducedToast.toast.title)), /*#__PURE__*/react.createElement("p", {
    className: "mt-1 text-sm text-gray-500"
  }, reducedToast.toast.description)), /*#__PURE__*/react.createElement("div", {
    className: "ml-4 flex flex-shrink-0"
  }, /*#__PURE__*/react.createElement("button", {
    type: "button",
    className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
    onClick: () => setIsShown(false)
  }, /*#__PURE__*/react.createElement("span", {
    className: "sr-only"
  }, gettext('Close')), /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "x"
  }))))));
}
/* harmony default export */ const toast_ToastMessage = ((0,mobxreact_esm/* observer */.PA)(ToastMessage));
// EXTERNAL MODULE: ./react/ui/toast/ToastStore.ts
var ToastStore = __webpack_require__(2102);
;// ./react/ui/toast/ToastContainer.tsx




function ToastContainer() {
  const toastStore = (0,ToastStore/* useToastStore */.WE)();
  const onClose = id => {
    toastStore.removeToast(id);
  };
  const toasts = toastStore.toasts;
  return toasts.length ? /*#__PURE__*/react.createElement("div", {
    className: "pointer-events-none fixed inset-0 flex flex-col items-end justify-start px-4 py-6 sm:p-6"
  }, toasts.map(reducedToast => /*#__PURE__*/react.createElement(toast_ToastMessage, {
    key: reducedToast.toast.id,
    reducedToast: reducedToast,
    onClose: () => onClose(reducedToast.toast.id)
  }))) : null;
}
/* harmony default export */ const toast_ToastContainer = ((0,mobxreact_esm/* observer */.PA)(ToastContainer));

/***/ }),

/***/ 2102:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ay: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   WE: () => (/* binding */ useToastStore),
/* harmony export */   yG: () => (/* binding */ ToastStoreContext)
/* harmony export */ });
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41906);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96540);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27813);
var _dec, _dec2, _dec3, _class, _descriptor;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }



function getTimestamp() {
  return Math.floor(Date.now() / 1000);
}
let ToastStore = (_dec = mobx__WEBPACK_IMPORTED_MODULE_2__/* .action */ .XI.bound, _dec2 = mobx__WEBPACK_IMPORTED_MODULE_2__/* .action */ .XI.bound, _dec3 = mobx__WEBPACK_IMPORTED_MODULE_2__/* .action */ .XI.bound, (_class = class ToastStore {
  constructor() {
    this.MAX_AGE = 30;
    // seconds
    _initializerDefineProperty(this, "intetnalToasts", _descriptor, this);
    (0,mobx__WEBPACK_IMPORTED_MODULE_2__/* .makeObservable */ .Gn)(this);
  }
  addToast(toast) {
    this.intetnalToasts.push(_objectSpread({
      id: JSON.stringify({
        type: toast.type,
        title: toast.title,
        description: toast.description
      }),
      timestamp: getTimestamp()
    }, toast));
    this.removeOutdatedToasts();
  }
  removeToast(id) {
    this.intetnalToasts = this.intetnalToasts.filter((0,mobx__WEBPACK_IMPORTED_MODULE_2__/* .action */ .XI)(storeItem => storeItem.id !== id));
    this.removeOutdatedToasts();
  }
  removeOutdatedToasts() {
    const now = getTimestamp();
    this.intetnalToasts.filter((0,mobx__WEBPACK_IMPORTED_MODULE_2__/* .action */ .XI)(item => item.timestamp + this.MAX_AGE > now));
  }
  get toasts() {
    const now = getTimestamp();
    return Object.values(this.intetnalToasts.filter(item => item.timestamp + this.MAX_AGE > now).reduce((acc, cur) => {
      if (cur.id in acc) {
        acc[cur.id].count += 1;
      } else {
        acc[cur.id] = {
          count: 1,
          toast: cur
        };
      }
      return acc;
    }, {}));
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intetnalToasts", [mobx__WEBPACK_IMPORTED_MODULE_2__/* .observable */ .sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "addToast", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "addToast"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeToast", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "removeToast"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeOutdatedToasts", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "removeOutdatedToasts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toasts", [mobx__WEBPACK_IMPORTED_MODULE_2__/* .computed */ .EW], Object.getOwnPropertyDescriptor(_class.prototype, "toasts"), _class.prototype)), _class));
const ToastStoreContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
const useToastStore = () => (0,helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .useContextSafe */ .qr)(ToastStoreContext);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ToastStore);

/***/ }),

/***/ 2965:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./cs": 56464,
	"./de": 77853,
	"./sk": 5784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2965;

/***/ })

}]);